import axios from "axios";
import { API_URL, GET_ERRORS, IS_LOADING } from "./types";
import { tokenConfig } from "../utils/tokenConfig";

export const initialCalls =
  (getCasesAndProjects, getDefaultParams, getLoads, getConfigurationsMap) =>
  async (dispatch) => {
    try {
      dispatch({
        type: IS_LOADING,
      });
      getCasesAndProjects();
      getDefaultParams();
      getLoads();
      getConfigurationsMap();
      dispatch({
        type: IS_LOADING,
      });
    } catch (err) {
      dispatch({
        type: IS_LOADING,
      });
      const errors = {
        msg: err.response.data,
        status: err.response.status,
      };
      dispatch({
        type: GET_ERRORS,
        payload: errors,
      });
    }
  };
